import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MGProgressSpinner } from "@/components/progress";
import MGSurface from "@/app/app-components/MGSurface/MGSurface";
import { MGHeading3 } from "@/components/typography";
import { MGSpacing } from "@/components/spacing";
import useHomePageStudentSearch from "./useHomePageStudentSearch";
import "./style.css";

const HomePageStudentSearch = () => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const { students, loading, debounceSearch } = useHomePageStudentSearch();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (e) => {
    const val = e.target.value;
    setInputValue(val);
    debounceSearch(val);
    setIsOpen(val.length > 0);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
    setInputValue("");
    debounceSearch("");
  };

  return (
    <MGSurface>
      <MGHeading3>{t("Student Search")}</MGHeading3>
      <br />
      <div className="home-student-search" ref={containerRef}>
        <input
          className="home-student-search__input"
          placeholder={t("Search for a student...")}
          value={inputValue}
          onChange={handleChange}
          onFocus={() => inputValue && setIsOpen(true)}
        />

        {isOpen && (
          <div className="--mg-menu home-student-search__dropdown">
            {loading && (
              <div className="--mg-menu-item home-student-search__spinner">
                <MGProgressSpinner size="16" />
              </div>
            )}
            {!loading && students.length === 0 && (
              <div className="--mg-menu-item">{t("No students found")}</div>
            )}
            {!loading &&
              students.map((student) => (
                <div key={student.id} className="--mg-menu-item">
                  <div style={{ display: "flex" }}>
                    <div style={{ flex: 1, display: "flex", alignItems: "center", overflow: "hidden" }}>
                      <MGSpacing size={"sm"} />
                      <Link
                        to={`/students/${student.id}`}
                        className="home-student-search__name-link"
                        onClick={handleLinkClick}
                      >
                        {student.full_name}
                      </Link>
                      <MGSpacing size={"sm"} />
                    </div>
                    {student.devices.length > 0 && (
                      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-end", gap: "4px", paddingRight: "var(--mg-spacing-sm)" }}>
                        {student.devices.map((device) => (
                          <Link
                            key={device.device_uuid}
                            to={`/devices/${device.device_uuid}`}
                            className="home-student-search__serial-link"
                            onClick={handleLinkClick}
                          >
                            {device.serial}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>
    </MGSurface>
  );
};

export default HomePageStudentSearch;
